import React, { useState } from 'react';
import './InterviewQuestionItem.css';

const InterviewQuestionItem = ({ question, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="interview-question-item">
      <div 
        className="question-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="question-number">
          <span className="badge">{index}</span>
        </div>
        <div className="question-content">
          <h4>{question.question}</h4>
          <span className={`toggle-icon ${isExpanded ? 'expanded' : ''}`}>
            <i className="bx bx-chevron-down"></i>
          </span>
        </div>
      </div>

      {isExpanded && (
        <div className="answer-content">
          <div 
            className="answer-text"
            dangerouslySetInnerHTML={{ __html: question.answer }}
          />
        </div>
      )}
    </div>
  );
};

export default InterviewQuestionItem;